export default {
  title: 'Select tools',
  dmaker: {
    title: 'Customized creative',
    subtitle: 'All your customized creatives from Mindworks',
  },
  gmaker: {
    title: 'Playable Production Tool',
    subtitle:
      'Fast playable production with templates, create from blank with Ad Editor',
  },
  vmaker: {
    title: 'Video Ads Production Tool',
    subtitle: 'Smart editing & batch operation',
  },
}
